import { render } from "./IconTrash.vue?vue&type=template&id=1f776056"
import script from "./IconTrash.vue?vue&type=script&lang=ts"
export * from "./IconTrash.vue?vue&type=script&lang=ts"
script.render = render

export default script